import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12h4.5l1.5 -6l4 12l2 -9l1.5 3h4.5","key":"svg-0"}]]

/**
 * IconActivityHeartbeat
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYWN0aXZpdHktaGVhcnRiZWF0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0zIDEyaDQuNWwxLjUgLTZsNCAxMmwyIC05bDEuNSAzaDQuNSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/activity-heartbeat
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconActivityHeartbeat = createReactComponent('outline', 'activity-heartbeat', 'ActivityHeartbeat', __iconNode);

export default IconActivityHeartbeat;